import InsightSummary from "../../components/Insights/summary";
import { selectClient } from "../../actions/App";
import { connect } from "react-redux";
import { getClientSites, getClientProfile } from "../../actions/Clients";
import {
  setReportWebSiteId,
  setReportDayRange,
  sendAssistRequest,
  getOverviewTrafficeReport,
  getDomesticConsumerStats,
  getStatsByTime,
  getDomesticBusinessStats,
  clearAllDomesticStats,
  setReportGranularity,
} from "../../actions/Insights";
const mapStateToProps = state => {
  const {
    websiteId,
    dayRange,
    granularity,
    send_assist_request_error,
    overviewTrafficReport,
    statsByTime,
    request_assist_successful,
    domesticConsumerVisitsReport,
    domesticBusinessVisitsReport,
    loadingOverviewTraffic,
    loadingDomesticConsumerVisits,
    loadingDomesticBusiness,
    loadingStatsByTime,
  } = state.insights;
  const { selected_client, clients, client_info } = state.app;
  const { client_sites } = state.clients;
  return {
    websiteId,
    dayRange,
    granularity,
    selected_client,
    clients,
    client_sites,
    send_assist_request_error,
    request_assist_successful,
    overviewTrafficReport,
    domesticConsumerVisitsReport,
    statsByTime,
    domesticBusinessVisitsReport,
    loadingOverviewTraffic,
    loadingDomesticBusiness,
    loadingDomesticConsumerVisits,
    loadingStatsByTime,
    client_info,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getClientSites: cid => {
      dispatch(getClientSites(cid, true));
    },

    getClientProfile: cid => {
      dispatch(getClientProfile(cid));
    },

    setWebsiteId: id => {
      dispatch(setReportWebSiteId(id));
      dispatch(clearAllDomesticStats());
    },
    selectClient: clientId => {
      dispatch(selectClient(clientId));
    },
    setDateRange: str => {
      dispatch(setReportDayRange(str));
      dispatch(clearAllDomesticStats());
    },
    setGranularity: str => {
      dispatch(setReportGranularity(str));
    },
    sendAssistRequest: data => {
      dispatch(sendAssistRequest(data));
    },

    getOverviewTrafficeReport: (tagId, dateRange) => {
      dispatch(getOverviewTrafficeReport(tagId, dateRange));
    },

    getDomesticConsumerStats: (tagId, dateRange, granularity) => {
      dispatch(getDomesticConsumerStats(tagId, dateRange, granularity));
    },

    getStatsByTime: (wid, dateRange, page, type) => {
      dispatch(getStatsByTime(wid, dateRange, page, type));
    },

    getDomesticBusinessStats: (tagId, granularity, dateRange) => {
      dispatch(getDomesticBusinessStats(tagId, dateRange, granularity));
    },

    clearAllDomesticStats: () => {
      dispatch(clearAllDomesticStats());
    },
  };
};

const InsightSummaryContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InsightSummary);

export default InsightSummaryContainer;



// WEBPACK FOOTER //
// ./src/containers/Insights/Summary.js